import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { chatActions } from "../../../../../_actions";
import { floorplanActions } from "../../../../../_actions";
import FloorplanImage from "./Image.Floorplan";
import FloorplanDetails from "./Details.Floorplan";
import { rightArrow } from "./styles";
import { language, translate } from "../../../../../_helpers/general.helper";
import { useWindowSize } from "../../../Utility/hooks";

const FloorplanContainer = styled.div`
  margin-bottom: 3px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid #dfdfdf;
  margin-bottom: 15px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 3px 3px 6px 0px rgba(169, 169, 169, 0.25);
  position: relative;
  width: 100%;
  margin-right: 10px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakMedium}) {
    width: 580px;
    margin-left: auto;
    margin-right: auto;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 787px;
    height: 218px;
    flex-direction: row;
    background-color: #fbfbfb;
  }
`;

const ImageTag = styled.img`
  width: 26px;
  height: 20px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    width: 35px;
    height: 29px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 43.59px;
    height: 36.12px;
    margin-bottom: 6px;
  }
`;

const BestMatch = styled.div`
  border-radius: 50%;
  background: #42accd;
  color: #fff;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 700;
  opacity: 0.9;
  text-transform: uppercase;
  top: 0;
  width: 78px;
  height: 78px;
  z-index: 10;
  display: ${(props) =>
    props.available_units > 0 && props.units_in_range ? "block" : "none"};

  @media screen and (max-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    right: -28px;
    img {
      margin-top: 14px;
      margin-left: 20px;
    }

    span {
      margin-right: 26px;
      margin-left: 25px;
      line-height: 16px;
    }

    z-index: 10;
  }

  @media screen and (max-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    right: -22px;
    img {
      margin-top: 11px;
      margin-left: 10px;
    }

    z-index: 10;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    width: 110px;
    height: 110px;

    img {
      margin-top: 20px;
      margin-left: 10px;
    }

    span {
      margin-right: 26px;
      margin-left: 25px;
      line-height: 22px;
    }

    z-index: 10;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 137px;
    height: 137px;
    left: -20px;
    top: -20px;
    z-index: 10;
  }
`;

const BannerText = styled.div`
  font-family: Cabin;
  font-style: normal;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  margin-top: 4px;

  span:nth-child(1) {
    font-size: 16px;
    line-height: 14px;
  }

  span:nth-child(2) {
    font-size: 10px;
    line-height: 10px;
  }

  span:nth-child(3) {
    font-size: 13px;
    line-height: 10px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    span:nth-child(1) {
      font-size: 18px;
      line-height: 14px;
    }

    span:nth-child(2) {
      font-size: 14px;
      line-height: 14px;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    span:nth-child(1) {
      font-size: 24px;
      line-height: 24px;
    }

    span:nth-child(2) {
      font-size: 18px;
      line-height: 14px;
    }
  }
`;

const InPriceRange = styled(BestMatch)`
  background: #666;
  position: absolute;

  &:before {
    border: 4px solid #666;
    border-bottom-color: transparent;
    border-left-color: transparent;
  }
`;

const UnitsAvailable = styled.div`
  z-index: 10;
  position: absolute;
  width: 210px;
  height: 55px;
  left: 2px;

  background: rgba(66, 172, 205, 0.92);
  border-radius: 0px 50px 50px 0px;

  span {
    margin: auto;
    position: absolute;
    top: 0;
    left: 15px;
    bottom: 0;
    right: 0;

    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 18px;

    display: flex;
    align-items: center;
    text-align: center;

    color: #ffffff;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    top: 175px;
    height: 42px;
    width: 175px;

    span {
      font-size: 16px;
    }

    p {
      font-size: 12px;
      color: #ffffff;
      text-align: left;
      line-height: 0px;
      padding-top: ${(props) =>
        props.available_units > 0 && props.units_in_range ? "11px" : "21px"};
      padding-left: 8px;
    }

    hr {
      display: ${(props) =>
        props.available_units > 0 && props.units_in_range ? "block" : "none"};
      margin-top: -5px;
      margin-bottom: -3px;
      border: 0;
      border-top: 1px solid rgba(255, 255, 255);
    }
  }

  @media screen and (max-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    top: 10px;
    left: 3px;
    height: 32px;
    width: 145px;

    span {
      font-size: 14px;
    }

    p {
      font-size: 10px;
      color: #ffffff;
      text-align: left;
      line-height: 0px;
      padding-top: ${(props) =>
        props.available_units > 0 && props.units_in_range ? "8px" : "16px"};
      padding-left: 8px;
    }

    hr {
      display: ${(props) =>
        props.available_units > 0 && props.units_in_range ? "block" : "none"};
      margin-top: -9px;
      margin-bottom: -1px;
      border: 0;
      border-top: 1px solid rgba(255, 255, 255);
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    top: 300px;
    height: 55px;
    width: ${(props) =>
      props.available_units > 0 && props.units_in_range ? "210px" : "195px"};

    span {
      font-size: 18px;
    }

    p {
      font-size: 13px;
      color: #ffffff;
      text-align: left;
      line-height: 0px;
      padding-top: ${(props) =>
        props.available_units > 0 && props.units_in_range ? "11px" : "25px"};
      padding-left: 8px;
    }

    hr {
      display: ${(props) =>
        props.available_units > 0 && props.units_in_range ? "block" : "none"};
      margin-top: 3px;
      margin-bottom: 1px;
      border: 0;
      border-top: 1px solid rgba(255, 255, 255);
    }
  }
`;

const OpenFloorplan = styled.div`
  height: 40px;
  width: 100%;
  border-radius: 0px 0px 8px 8px;
  color: white;
  background: var(--Primary-Blue, #42accd);
  font-family: "DM Sans";
  font-size: 15px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #eee;
  display: flex;
  cursor: pointer;
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 500;

  svg {
    position: absolute;
    right: 25px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    height: 60px;
    font-size: 22px;
    height: 218px;
    width: 47px;
    border-radius: 0 8px 8px 0;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    bottom: 1px;
    svg {
      position: relative;
      right: 0;
    }
  }

  &:hover {
    background-color: #3da0bf;
  }
`;

const banners = {
  none: null,
  best: BestMatch,
  range: InPriceRange,
};

function Container({
  data,
  selected,
  tid,
  setFloorplan,
  setFloorplanUnits,
  getUnitsData,
  lang
}) {
  if (!(data.price_from || data.price_to)) {
    data.flag = "none";
  }

  const { width } = useWindowSize();


  const mapVirtualTours = (data) => {
    let floorplanVitrualTours = data.virtual_tours;
    data.units &&
      data.units.forEach((floorplanUnit) => {
        let rawVT =
          floorplanUnit.virtual_tour && floorplanUnit.virtual_tour.split(",");
        if (rawVT) {
          let finalVT =
            rawVT &&
            rawVT.map((tour) => {
              return {
                name: `${lang === "English" ? 'Unit' : 'Unidad' } ${floorplanUnit.unit_number}`,
                url: tour,
              };
            });

          floorplanVitrualTours = [...floorplanVitrualTours].concat(finalVT);
        }
      });
    return floorplanVitrualTours
  }

  const selectFloorplan = () => {
    const floorPlanUnits = data.units
      ? data.units.map((unit) => unit.unit_number)
      : [];
  
    const selectedFloorplan = { ...data, virtual_tours: mapVirtualTours(data) };
    getUnitsData({
      message: data.text,
      driver: "web",
      gaEvent: data.text,
      dataType: "normal",
      checkRatedUs: true,
    });
    setFloorplanUnits(floorPlanUnits);
    setFloorplan(selectedFloorplan);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      selectFloorplan();
    }
  };

  return (
    <FloorplanContainer className="FloorplanContainer">
      <FloorplanImage
        className="FloorplanImage"
        src={data.src}
        name={data.name}
        selected={selected}
        floorplan={data}
        tid={tid}
        onKeyPress={(e) => handleKeyPress(e)}
      />
      {width < 1024 && (
        <FloorplanDetails className="FloorplanDetails" data={data} />
      )}
      <OpenFloorplan onClick={selectFloorplan}>
        {width < 1024 && <span>{translate(`${!data.units ? 'See details' : 'Select'}`, language(tid))}</span>}
        {rightArrow}
      </OpenFloorplan>
    </FloorplanContainer>
  );
}

const mapStateToProps = (state) => ({
  tid: state.settings.tid,
  lang: state.settings.language,
});

const mapDispatchToProps = {
  send: chatActions.send,
  setFloorplan: floorplanActions.setFloorplan,
  setFloorplanUnits: floorplanActions.setFloorplanUnits,
  getUnitsData: floorplanActions.getUnitsData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
